
import React from 'react';

const CheckmarkCyan = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			fill='none'
			viewBox='10 2 24 24'
		>
			<g filter='url(#filter0_ddd_1931_2222)'>
				<circle
					cx='22'
					cy='14'
					r='10.25'
					fill='#7BDBDC'
					stroke='#7BDBDC'
					strokeWidth='1.5'
				></circle>
				<path
					fill='#3F062B'
					d='M27.55 9.68c-.6-.64-1.5-.64-2.1 0l-4.95 5.28-1.95-2.08c-.6-.64-1.5-.64-2.1 0-.6.64-.6 1.6 0 2.24l3 3.2c.3.32.75.48 1.05.48.3 0 .75-.16 1.05-.48l6-6.4c.6-.64.6-1.6 0-2.24z'
				></path>
			</g>
			<defs>
				<filter
					id='filter0_ddd_1931_2222'
					width='24'
					height='24'
					x='10'
					y='2'
					colorInterpolationFilters='sRGB'
					filterUnits='userSpaceOnUse'
				>
					<feFlood floodOpacity='0' result='BackgroundImageFix'></feFlood>
					<feColorMatrix
						in='SourceAlpha'
						result='hardAlpha'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
					></feColorMatrix>
					<feOffset dy='2'></feOffset>
					<feGaussianBlur stdDeviation='1'></feGaussianBlur>
					<feColorMatrix values='0 0 0 0 0.482353 0 0 0 0 0.858824 0 0 0 0 0.862745 0 0 0 0.15 0'></feColorMatrix>
					<feBlend
						in2='BackgroundImageFix'
						result='effect1_dropShadow_1931_2222'
					></feBlend>
					<feColorMatrix
						in='SourceAlpha'
						result='hardAlpha'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
					></feColorMatrix>
					<feOffset dy='5'></feOffset>
					<feGaussianBlur stdDeviation='2.5'></feGaussianBlur>
					<feColorMatrix values='0 0 0 0 0.482353 0 0 0 0 0.858824 0 0 0 0 0.862745 0 0 0 0.1 0'></feColorMatrix>
					<feBlend
						in2='effect1_dropShadow_1931_2222'
						result='effect2_dropShadow_1931_2222'
					></feBlend>
					<feColorMatrix
						in='SourceAlpha'
						result='hardAlpha'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
					></feColorMatrix>
					<feOffset dy='8'></feOffset>
					<feGaussianBlur stdDeviation='5'></feGaussianBlur>
					<feColorMatrix values='0 0 0 0 0.482353 0 0 0 0 0.858824 0 0 0 0 0.862745 0 0 0 0.1 0'></feColorMatrix>
					<feBlend
						in2='effect2_dropShadow_1931_2222'
						result='effect3_dropShadow_1931_2222'
					></feBlend>
					<feBlend
						in='SourceGraphic'
						in2='effect3_dropShadow_1931_2222'
						result='shape'
					></feBlend>
				</filter>
			</defs>
		</svg>
	);
};

export default CheckmarkCyan;
